


















































import { Component, Vue } from 'vue-property-decorator'
import { Notify } from '@/helpers/Notify'
import { Helper } from '@/helpers/Helper'
import { Api } from '@/fetch/Api'
import store from '@/store'
import VueProgrammaticInvisibleGoogleRecaptcha from 'vue-programmatic-invisible-google-recaptcha'
import { loadScript } from 'vue-plugin-load-script'

@Component({
  components: {
    VueProgrammaticInvisibleGoogleRecaptcha,
  },
})
export default class ForgotPassword extends Vue {
  callInProgress = false
  email: string = null
  RequestDisabled = true

  created() {
    loadScript('https://www.google.com/recaptcha/api.js?render=explicit')
    setTimeout(this.enableLoginButton, 5000)
  }

  public executeCaptcha() {
    (this.$refs.invisibleRecaptcha1 as any).execute()
  }

  public async forgotPasswordRequest(recaptchaToken) {
    this.callInProgress = true
    try {
      const forgotPasswordResult = await Api.forgotPassword(this.email, recaptchaToken, Helper.getCurrentDomain())
      this.callInProgress = false
      Notify.create({
        type: 'success',
        title: 'Email Sent!',
        text: forgotPasswordResult.message,
      })
      this.$router.push({ path: '/' })
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public enableLoginButton() {
    this.RequestDisabled = false
  }
}
